import type { GetArtistPagePublishingBooksQuery } from '#lib/websites/artists/queries/__generated__/getArtistPagePublishingBooks.generated.js';

export const transformInfiniteDataPublishing = (
	data: GetArtistPagePublishingBooksQuery | undefined
) =>
	(data?.Publishing_Books || []).filter(
		Boolean
	) as GetArtistPagePublishingBooksQuery['Publishing_Books'];
